import React, { useState, useEffect, useContext } from 'react'
import { Route, useLocation, Switch } from 'react-router-dom'
import { useHistory } from 'react-router-dom/cjs/react-router-dom'
import { Redirect } from 'react-router'
import Favourites from './Favourites'
import Checkout from './Checkout'
import Cart from './cart'
import ProductAuction from './ProductAuction'
import Invoice from './Invoices/Invoice'
import ChangePassword from './ChangePassword'
import faq from './StaticPages/faq'
import howItWorks from './StaticPages/howItWorks'
import privacy_policy from './StaticPages/privacypolicy'
import aboutus from './StaticPages/aboutus'
import Login from './Login'
import ForgotPassword from './ForgotPassword'
import Registration from './Registration'
import Activateaccount from './Activateaccount'
import Home from './Home'
import Search from './Search'
import AuctionSearch from './AuctionSearch'
import Gallery from './Gallery'
import Profile from './Profile'
import SavedSearch from './SavedSearch'
import Dashboard from './Dashboard'
import Transactions from './Transactions'
import Cards from './cards'
import AuthContext from '../../Product/context/auth/authContext'
import EstateLiquidations from './StaticPages/estateLiquidations'
import InventoryReduction from './StaticPages/inventoryReduction'
import BusinessLiquidations from './StaticPages/businessLiquidations'
import termsOfService from './StaticPages/termsOfService'
import Conditions from './StaticPages/conditions'
import ProductView from './ProductView'
import Auctions from './Auctions'
import { commonPaths } from '../../utils/commonFunctions'
import MaintenanceMode from './MaintenanceMode'
import LiveAuctionView from './LiveAuction/LiveAuctionView'
import LiveAuction from './LiveAuction'
import Static from './Static'
import DynamicStaticPage from './Static/commonIndex.js'
import Ticketing from '../../utils/CommonFunctionality/Ticketing'
import EventAuction from './EventAuction'
import mytickets from './MYTickets'
import ContactUs from './ContactUs'
import IdleTimerContainer from '../../utils/IdleTimerContainer'
import Preference from './Preference'
import Referral from './Referral'
import Paypalsuccess from './Paypalpaymentsucess'
import Paypalcancel from './Paypalpaymentcancel'
import Subscription from './Subscription'
import Billing from './Subscription/Billing'
import Pos from './Pos'
import PosLocation from '../../utils/CommonFunctionality/Pos/Location'
import PosReaders from '../../utils/CommonFunctionality/Pos/Readers'
import PosCheckout from './Pos/Checkout'
import AuctionCart from './AuctionCart'
import ReverseAuctions from './Reverse Auctions'
import Barcode from './Barcode'
import QRcode from './QRcode/index.js'
import return_policy from './StaticPages/returnPolicy'
import rush_perks from './StaticPages/rushPerks.js'
import Location_hours from './Location/index'
import Careers from './StaticPages/careers'
import SellWithUs from './StaticPages/sellWithUs'
import BinStore from './StaticPages/binStore'
import SellerInfo from './StaticPages/sellerInfo'
import Location from './StaticPages/location'
import Warranty from './Warranty/index.js'
import Abandoned from './MyScheduling/abandoned'
import ScheduledPickup from './MyScheduling/scheduledPickup'
import Rewards from './Rewards'
import Redeem from './Redeem'
import MyCart from './MyCart'
import ExtendedPickup from './ExtendedPickup/index.js'
import rushBins from './StaticPages/rushBins.js'
import SiteMap from './StaticPages/siteMap.js'
import { handleRedirectInternal } from '../../Product/common/components'
import AlertContext from '../../Product/context/alert/alertContext'
import NotFound from './StaticPages/pageNotFound.js'
import RushPass from './RushPass/index.js'

const PrivateRoute = ({ component: Component, ...rest }) => (
    <>
        <Route
            {...rest}
            render={(props) =>
                localStorage.token ? (
                    <Component {...props} />
                ) : (
                    <Redirect
                        to={{
                            pathname: '/login',
                            state: { from: props.location },
                        }}
                    />
                )
            }
        />
    </>
)

export default function LiquidationRoutes() {
    const isRetailRushTheme = global.storeConfigration?.bodyClass?.value === 'greenField'

    const { pathname } = useLocation()
    const [isRedirecting, setIsRedirecting] = useState(false)
    const alertContext = useContext(AlertContext)
    const authContext = useContext(AuthContext)

    const { user } = authContext
    const { setAlert } = alertContext
    const history = useHistory()

    const getStaticPageData = global?.staticDetails || []

    useEffect(() => {
        if (user && !isRedirecting && isRetailRushTheme) {
            if (
                user.status == 'suspended' &&
                pathname != '/dashboard/billing' &&
                pathname != '/dashboard/cards'
            ) {
                setIsRedirecting(true)
                handleRedirectInternal(history, `dashboard/billing`)
                setAlert(
                    'Your account has been suspended due to payment issues. Please pay the reactivation fee to be able to bid again.',
                    'error',
                )
            }
        }
    }, [pathname, user, isRedirecting])
    const isBuyBestProject = global.storeConfigration?.bodyClass2?.value === 'buyBestProject'
    // script adding for google manager tag
    useEffect(() => {
        if (isRetailRushTheme) {
            const gtmScript = document.createElement('script')
            gtmScript.async = true
            gtmScript.src = `https://www.googletagmanager.com/gtm.js?id=${global.storeConfigration?.google_analytics?.value}`
            document.body.appendChild(gtmScript)

            const inlineScript = document.createElement('script')
            inlineScript.innerHTML = `
            window.dataLayer = window.dataLayer || [];
            window.dataLayer.push({
              'gtm.start': new Date().getTime(),
              event: 'gtm.js'
            });
          `
            document.body.appendChild(inlineScript)

            if (global.storeConfigration?.fb_meta_pixel_id?.value) {
                const pixelScript = document.createElement('script')
                pixelScript.innerHTML = `
             !function (f, b, e, v, n, t, s) {
            if (f.fbq) return;
            n = f.fbq = function () {
                n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments)
            };
            if (!f._fbq) f._fbq = n;
            n.push = n;
            n.loaded = !0;
            n.version = '2.0';
            n.queue = [];
            t = b.createElement(e);
            t.async = !0;
            t.src = v;
            s = b.getElementsByTagName(e)[0];
            s.parentNode.insertBefore(t, s)
        }(window, document, 'script', 'https://connect.facebook.net/en_US/fbevents.js');
        fbq('init', '${global.storeConfigration?.fb_meta_pixel_id?.value}'); fbq('track', 'PageView');
          `
                document.head.appendChild(pixelScript)

                const pixelNoScript = document.createElement('noscript')
                pixelNoScript.innerHTML = `<img height="1" width="1" src="https://www.facebook.com/tr?id=${global.storeConfigration?.fb_meta_pixel_id?.value}&ev=PageView&noscript=1"/>`
                document.head.appendChild(pixelNoScript)
            }

            return () => {
                document.body.removeChild(gtmScript)
                document.body.removeChild(inlineScript)
                if (global.storeConfigration?.fb_meta_pixel_id?.value) {
                    document.head.removeChild(pixelScript)
                    document.head.removeChild(pixelNoScript)
                }
            }
        }
    }, [isRetailRushTheme])

    // meta tag adding
    useEffect(() => {
        if (isRetailRushTheme) {
            const pathSegment = window.location.pathname.split('/')[2]

            let metaContent = ''

            if (pathSegment === 'aboutus') {
                metaContent =
                    "At Retail Rush, shopping isn't just a transaction—it's a thrill! It's about the joy of scoring that incredible find you didn't think you could afford. We believe every purchase should feel like a win. Whether it's through our buzzing online auctions or the excitement of our in-store deals, we make smart shopping simple—and seriously fun."
            } else if (pathSegment === 'binStore') {
                metaContent =
                    'Our bin store offers deeply discounted items from major retailers. Products are placed in bins and the price you pay depends on the day you shop—higher on restock day, and dropping daily after that. It’s a fun, first-come-first-served treasure hunt!'
            } else if (pathSegment === 'location') {
                metaContent =
                    'Welcome to the future of smart shopping! At Retail Rush, you get name-brand products, steep discounts, and the convenience of local pickup or delivery—all in one place. As we expand nationwide, you’ll always have a trusted destination for incredible deals close to home.'
            } else if (pathSegment === 'conditions') {
                metaContent =
                    "When participating in Retail Rush online auctions, it's essential to understand the condition of the items you're bidding on. Being aware of product conditions helps you make informed decisions and ensures that you know what to expect when you come to pick up your purchase at Retail Rush."
            } else if (pathSegment === 'contact_us') {
                metaContent = 'Retail Rush Contact Customer Support'
            }

            if (metaContent) {
                const gfMeta = document.createElement('meta')
                gfMeta.name = 'description'
                gfMeta.content = metaContent
                document.head.appendChild(gfMeta)
                return () => {
                    document.head.removeChild(gfMeta)
                }
            }
        }
    }, [window.location.pathname])

    return (
        <>
            <Switch>
                <Route exact path="/maintenance" component={MaintenanceMode} />
                <Route exact path="/" component={Home} />
                <Route exact path="/faq" component={faq} />
                <Route exact path="/aboutus" component={aboutus} />
                <Route exact path="/inventoryReduction" component={InventoryReduction} />
                <Route exact path="/estateLiquidations" component={EstateLiquidations} />
                <Route exact path="/businessLiquidations" component={BusinessLiquidations} />
                <Route exact path="/termsOfService" component={termsOfService} />
                <Route exact path="/conditions" component={Conditions} />
                <Route exact path="/how_it_works" component={howItWorks} />
                <Route exact path="/search" component={AuctionSearch} />
                <Route exact path="/search/:cat_title" component={AuctionSearch} />
                <Route exact path="/todays-top-deals" component={AuctionSearch} />
                <Route exact path="/recently-listed" component={AuctionSearch} />
                <Route exact path="/deals-ending-soon" component={AuctionSearch} />
                <Route exact path="/buynow" component={AuctionSearch} />
                <Route exact path="/product/:id" component={ProductView} />
                <Route exact path="/auctions" component={Auctions} />
                <Route exact path="/reverse-auction" component={ReverseAuctions} />
                <Route exact path="/gallery" component={Gallery} />
                <Route exact path="/login" component={Login} />
                <Route exact path="/careers" component={Careers} />
                <Route
                    exact
                    path={`${isBuyBestProject ? '/locations' : '/sell_with_us'}`}
                    component={SellWithUs}
                />
                <Route exact path="/binStore" component={BinStore} />
                <Route
                    exact
                    path={`${isBuyBestProject ? '/product_conditions' : '/become_a_seller'}`}
                    component={SellerInfo}
                />
                <Route exact path="/locations" component={Location} />
                <Route exact path="/search/autologin/:login_email" component={Login} />
                <Route exact path="/autologin/:login_email" component={Login} />
                <Route exact path="/search/auto-login/:login_email" component={Login} />
                <Route exact path="/auto-login/:login_email" component={Login} />
                <Route exact path="/auto-login-pos/:login_email" component={Login} />
                <Route exact path="/forgot_password" component={ForgotPassword} />
                <Route exact path="/sign-up" component={Registration} />
                <Route exact path="/activateaccount" component={Activateaccount} />
                <Route exact path="/login/forgot_password" component={ChangePassword} />
                <Route exact path="/search/product-buyer-auction/:id" component={ProductAuction} />
                <Route exact path="/eventAuction/:id" component={EventAuction} />
                <Route exact path="/changepasswordusers" component={ChangePassword} />
                <Route exact path="/ticketing/:sid/:aid" component={Ticketing} />
                <Route exact path="/location_hours" component={Location_hours} />
                <PrivateRoute exact path={commonPaths.profile} component={Profile} />
                <PrivateRoute exact path={commonPaths.mybids} component={Dashboard} />
                <PrivateRoute exact path="/dashboard/scheduledPickup" component={ScheduledPickup} />
                <PrivateRoute exact path="/dashboard/abandoned" component={Abandoned} />
                <PrivateRoute exact path="/dashboard/savedSearch" component={SavedSearch} />
                <PrivateRoute exact path="/dashboard/mybids/:status" component={Dashboard} />
                <PrivateRoute exact path="/dashboard/preference" component={Preference} />
                <PrivateRoute exact path="/dashboard/billing" component={Billing} />
                <PrivateRoute exact path="/dashboard/barcode" component={Barcode} />
                <PrivateRoute exact path="/dashboard/qrcode" component={QRcode} />
                <PrivateRoute exact path="/dashboard/warranty" component={Warranty} />
                <PrivateRoute exact path="/dashboard/rewards" component={Rewards} />
                <PrivateRoute exact path="/dashboard/redeem" component={Redeem} />
                <PrivateRoute exact path="/dashboard/extendedPickup" component={ExtendedPickup} />
                <PrivateRoute
                    exact
                    path={commonPaths.cart}
                    component={window.location.href.includes('pos') ? PosCheckout : Cart}
                />
                <PrivateRoute exact path={commonPaths.rushPass} component={RushPass} />
                <PrivateRoute exact path="/dashboard/mycart" component={MyCart} />
                <PrivateRoute exact path={commonPaths.auctionCart} component={AuctionCart} />
                {getStaticPageData.map((data) => (
                    <Route exact path={data.pathname} component={DynamicStaticPage} />
                ))}
                {/* {global.storeConfigration?.disable_buynow?.value !== '1' ? (
                <PrivateRoute exact path={commonPaths.cart} component={Cart} />
                ) : (
                    <Redirect to="/" />
                )} */}
                <PrivateRoute exact path={commonPaths.checkout} component={Checkout} />
                <PrivateRoute exact path={commonPaths.invoice} component={Invoice} />
                <PrivateRoute exact path={commonPaths.transaction} component={Transactions} />
                <PrivateRoute exact path={commonPaths.cards} component={Cards} />
                <PrivateRoute exact path={commonPaths.favorites} component={Favourites} />
                <PrivateRoute exact path={'/dashboard/subscription'} component={Subscription} />
                <PrivateRoute
                    exact
                    path={'/checkout/:auction/paypalsuccess'}
                    component={Paypalsuccess}
                />
                <PrivateRoute
                    exact
                    path={'/checkout/:auction/paypalcancel'}
                    component={Paypalcancel}
                />
                <PrivateRoute exact path="/dashboard/mytickets" component={mytickets} />
                <Route exact path="/liveauctionview/:id" component={LiveAuctionView} />
                <PrivateRoute exact path="/liveLots" component={LiveAuction} />
                <Route exact path="/privacy_policy" component={privacy_policy} />
                <Route exact path="/return_policy" component={return_policy} />
                <Route exact path="/rush_bins" component={rushBins} />
                <Route exact path="/rush_perks" component={rush_perks} />
                <Route exact path="/contact_us" component={ContactUs} />
                <PrivateRoute exact path="/referral" component={Referral} />
                {global?.storeConfigration?.session_timeout ? <IdleTimerContainer /> : ''}

                <PrivateRoute exact path="/dashboard/pos" component={Pos} />
                <PrivateRoute exact path="/dashboard/pos/location" component={PosLocation} />
                <PrivateRoute exact path="/dashboard/pos/readers" component={PosReaders} />
                <PrivateRoute exact path="/pos-checkout/:type" component={PosCheckout} />

                {/* PLEASE KEEP THIS IN LAST LINE */}
                <Route exact path="/*" component={NotFound} />
            </Switch>
        </>
    )
}
